import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  fetchRegistrationOffers,
  selectRegistrationOffers,
  selectRegistrationOffersDataState,
} from '@betty/registration/state';
import {
  fetchPromo,
  selectLandingPromoByType,
  selectLandingPromosDataState,
} from '@betty/auth';
import {
  Breakpoint,
  Swiper,
  useBreakpoint,
  useBreakpointProp,
  Box,
} from '@betty/moonlight';
import { useDispatch } from '@betty/toolkit/state';

function TopBannerPromos() {
  const dispatch = useDispatch();

  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const welcomePromo = useSelector(selectLandingPromoByType('Welcome'));
  const welcomePromoDataState = useSelector(selectLandingPromosDataState);

  useEffect(() => {
    if (welcomePromoDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, welcomePromoDataState]);

  const registrationOffers = useSelector(selectRegistrationOffers);
  const registrationOffersDataState = useSelector(
    selectRegistrationOffersDataState,
  );

  const imageWidth = useBreakpointProp({
    mobile: 108,
    tablet: 125,
    desktop: 125,
  });

  useEffect(() => {
    if (registrationOffersDataState === 'idle') {
      dispatch(fetchRegistrationOffers());
    }
  }, [dispatch, registrationOffersDataState]);

  const items = registrationOffers.map((offer) => ({
    image: offer.miniImageUrl,
  }));

  if (
    welcomePromo?.rewards.length === 1 &&
    welcomePromo.rewards[0].rewardTarget === 'FreeSpins'
  ) {
    return (
      <Box>
        <Box
          width="97%"
          marginHorizontal="auto"
          flexDirection="column"
          alignItems="center"
          height={{
            desktop: 125,
            tablet: 125,
            mobile: 108,
          }}
        >
          <Swiper
            items={items}
            itemWidth={imageWidth}
            itemRadius="radius-200"
            maxHeight="100%"
            loop={false}
            imageContentFit="cover"
            dragFree={true}
            slidesToScroll={2}
            itemsGap="space-400"
            arrows={isMobile ? false : true}
          />
        </Box>
      </Box>
    );
  }

  return null;
}

export default TopBannerPromos;
